import {
  BooleanField,
  CreateButton,
  Datagrid,
  List,
  NumberField,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export function CategoryList() {
  return (
    <List actions={<ListActions />} sort={{ field: 'name', order: 'ASC' }} perPage={50}>
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="slug" />
        <NumberField source="display_order" label="Order" />
        <BooleanField source="is_active" label="Active" />
      </Datagrid>
    </List>
  );
}
